module.exports = __webpack_public_path__ + "src/assets/img/cmdGoAlarm.80811d59.svg";